export interface ProductGroupFilterType {
  selectedProductGroups: server.dto.ProductGroup[]
}

export const getSortedProductGroups = (filter: ProductGroupFilterType) => {
  return filter.selectedProductGroups.map(b => b.title)
    .sort((a, b) => a.localeCompare(b));
};

export const initialProductGroupFilter: ProductGroupFilterType = {
  selectedProductGroups: []
};